import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { sectorRoleOptions } from '../../constants/sector-role-options';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-monitoring-filter',
  templateUrl: './monitoring-filter.component.html',
  styleUrls: ['./monitoring-filter.component.scss'],
  standalone: false,
})
export class MonitoringFilterComponent implements OnInit {
  @Input() filter;

  sectorRoleOptions = sectorRoleOptions;

  ngOnInit() {}

  onChangeRegions(regions) {
    this.filter.onChangeRegions(regions);
  }

  onChangeBranches(branches) {
    this.filter.onChangeBranches(branches);
  }

  onChangeDistricts(districts) {
    this.filter.onChangeDistricts(districts);
  }

  public handleSectorRoleChange(selectedSectorRole: ISelectOption) {
    this.filter.onChangeSectorRole(selectedSectorRole.value);
  }

  onChangeSectorsNumbers(sectorsNumbers) {
    this.filter.onChangeSectorsNumbers(sectorsNumbers);
  }
}
